
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-currency-exchange_svg-a)","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M16.004 15.5a7.5 7.5 0 100-15 7.5 7.5 0 000 15z"}}),_c('path',{attrs:{"d":"M8.53 8.526a7.5 7.5 0 106.949 6.948M.985 5.035l2.006 1.993 1.994-2.005"}}),_c('path',{attrs:{"d":"M7.973 1.013a5 5 0 00-4.985 5.015v1m20.035 11.937l-2.006-1.993-1.994 2.005"}}),_c('path',{attrs:{"d":"M16.035 22.987a5 5 0 003.531-1.475 5 5 0 001.454-3.54v-1M8.5 19.5a2.706 2.706 0 01-2.225-.775A2.707 2.707 0 015.5 16.5a2.707 2.707 0 013-3m-3.996 2h4m-4 2h3m9.996-13h-1.7a1.3 1.3 0 00-1.232 1.743 1.3 1.3 0 00.509.644l1.84 1.226A1.3 1.3 0 0116.2 10.5h-1.7m2.004-6v-1m-1 8v-1"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"gst-tenants-aadvantagehotels-app-modules-hotel-assets-svg-amenities-currency-exchange_svg-a"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    